class User {

    constructor() {
        this.init()
    }

    init() {
        this.name = localStorage.getItem('userName')
        this.email = localStorage.getItem('userEmail')
        this.loggedIn = localStorage.getItem('userLoggedIn')
        // console.log("init")
    }

    /**
     *
     * @param data object
     * @param data.name string
     * @param data.email string
     * @param callback function
     */
    authenticated(data, callback) {
        // console.log("jereeeeeeee")
        // localStorage.setItem('userName', data.name)
        // localStorage.setItem('userEmail', data.email)
        localStorage.setItem('userLoggedIn', 1)

        this.init()

        // callback()
    }

    /**
     *
     * @param data object
     * @param data.name string
     * @param data.email string
     * @param callback function
     */
    logout(data, callback) {
        // console.log("iiiiii")
        // localStorage.setItem('userName', data.name)
        // localStorage.setItem('userEmail', data.email)
        localStorage.removeItem('userLoggedIn')

        this.init()

        // document.location.href="/";
        // callback()
    }

    /**
     *
     * @return {boolean}
     */
    isLoggedIn() {
        return Boolean(this.loggedIn) === true
    }
}

export default new User()